var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      attrs: { size: "large", closable: false },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c("sui-modal-header", { staticStyle: { "text-align": "center" } }, [
        _vm._v("Edit Investment Strategy"),
      ]),
      _c(
        "sui-modal-content",
        { attrs: { scrolling: "" } },
        [
          _c("InvestmentStrategyForm", {
            ref: "form",
            attrs: { strategy: _vm.investmentStrategy },
          }),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              color: "grey",
              type: "button",
              content: "Cancel",
            },
            nativeOn: {
              click: function ($event) {
                return _vm.toggle.apply(null, arguments)
              },
            },
          }),
          _c("sui-button", {
            attrs: { primary: "", type: "button", content: "Save" },
            nativeOn: {
              click: function ($event) {
                return _vm.save.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }